<template>
  <b-card class="m-0">
    
    <h5 v-if="canViewTitle">{{ title }}</h5>

    <FormAddImagen 
      v-if="canAddImagenes"
      :imagenesList="imagenesList"
      :esIess="esIess"
    />

    <CardEnvioImagenes 
      :imagenesList="imagenesList"
      :onlyView="onlyView"
    />

    <b-alert 
      v-if="!imagenesList.length && alertNoRegistros" 
      variant="danger" 
      show class="text-center col-12"
      style="padding: 40px; font-size: 20px;">
      <i class="fa-solid fa-triangle-exclamation" />
      No ha registrado ninguna imagen
    </b-alert>

    <EditarEnvioImagen :imagenesList="imagenesList"/>
  </b-card>
  
</template>

<script>
import { imagenesService } from '@/views/imagen/services';
import FormAddImagen     from './FormAddImagen.vue';
import CardEnvioImagenes from './CardEnvioImagenes.vue';
import EditarEnvioImagen from './EditarEnvioImagen.vue';

export default {

  name: "RegistrarEnvioImagenes",

  props: {

    tokenAtencion: {
      type: String,
      default: null
    },

    esIess:{
      type:Boolean,
      default: false
    },

    maxEnvios: {
      type: Number,
      default: null 
    },


    alertNoRegistros: {
      type: Boolean,
      default: false
    },

    saveInState: {
      type: Function,
      default: null
    },

    respaldo: {
      type: Array,
      default: () => []
    },

    title:{
      type: String,
      default: null
    },

    onlyView: {
      type: Boolean,
      default: false
    }

  },


  components: {
    FormAddImagen,
    CardEnvioImagenes,
    EditarEnvioImagen
  },


  async created() {
    this.loadData();

    if(this.respaldo?.length){
      this.imagenesList = [...this.respaldo];
    }
  },

  data() {
    return {

      imagenesList: [],

    }
  },


  methods: {

    async loadData(){
      if(this.tokenAtencion){
        const responseImagenes = await imagenesService.getByAtencion(this.tokenAtencion);

        if(!responseImagenes) return;

        const extraerNumeroPieza = (texto = "") => {
          const match = (texto || "").match(/Numero de Pieza:\s*([^\n,]+)/i);
          return match ? match[1].trim() : "";
        };

        this.imagenesList = responseImagenes.map( imagen => {

          const imagenDetalle = {
            codigo: imagen.imagen.codigo,
            nombre: imagen.imagen.nombre,
            text: `(${imagen.imagen.codigo}) ${imagen.imagen.nombre}`,
            value: imagen.imagen.id
          };

          const lateralidad = {
            value: imagen.lateralidad.id,
            text: imagen.lateralidad.nombre
          };

          const numeroPieza = extraerNumeroPieza(imagen.motivoSolicitud) || extraerNumeroPieza(imagen.resumenClinico);

          return {
            action          : 'registrado',
            imagen          : imagenDetalle,
            numeroOrden     : imagen.numeroOrdenAs400,
            numeroPieza     : numeroPieza,
            motivoSolicitud : imagen.motivoSolicitud,
            resumenClinico  : imagen.resumenClinico,
            sedacion        : imagen.sedacion,
            lateralidad     : lateralidad,
            justificacion   : imagen.justificacion,
            idRegistro      : imagen.id,
            estadoImagen    : imagen.estadoImagen
          }
        });
      }
    },

  },


  computed: {

    canAddImagenes() {
      if (this.onlyView) return false;
      return this.maxEnvios === null || this.imagenesList.length < this.maxEnvios;
    },


    canViewTitle() {
      if(this.onlyView && !this.imagenesList.length) return false;
      return true;
    }

  },


  watch:{
    imagenesList: {
      deep: true,
      handler(newValue) {
        if(!this.saveInState) return;
        this.saveInState(newValue);
      }
    },


    tokenAtencion(newValue) {
      if(newValue) this.loadData();
    }
  }

}
</script>
